<template>
  <div>
    <modal name="request-join-chat-group-modal"
           :click-to-close="false"
           width="620px"
           height="auto"
           class="request-join-chat-group-modal modal-custom request-join-chat-group-modal"
           transition="easeInOut"
           @before-open="beforeOpened"
           @before-close="beforeClosed"
    >

      <md-card class="modal-header-custom">
        <md-dialog-title>
          <span class="neutral_1 heading-500 text-header-modal">Yêu cầu vào nhóm chat</span>
          <span class="material-icons float-right cursor-pointer"
                @click="$modal.hide('request-join-chat-group-modal')">close</span>
        </md-dialog-title>
      </md-card>

      <md-card-content>
        <div class="gs-group">
          <label class="heading-400 neutral_2 required">Link nhóm</label>
          <div class="heading-300 secondary_r400" v-show="showError.isError">{{showError.message}}</div>
          <input type="text" placeholder="Link nhóm" class="form-control input-custom mt-10px" required name="name"
                 v-model="linkGroup">
        </div>
      </md-card-content>

      <md-dialog-actions>
        <button type="submit" class="btn-active md-button text-400-medium" style="width: auto !important;" @click="requestJoin">
          <vue-element-loading :active="requestJoinLoading" spinner="bar-fade-scale"/>
          Gửi yêu cầu vào nhóm
        </button>
      </md-dialog-actions>

    </modal>
  </div>
</template>

<script>

import ChatService from "../../../store/services/ChatService";
import { parseMessengerGroupIdFromLink } from "../../../helper/chatGroupStore";

export default {
  name: 'request-join-chat-group-modal',
  data() {
    return {
      showError: {
        isError: false,
        message: '',
      },
      requestJoinLoading: false,
      linkGroup: '',
      chatGroupId: '',
      user: this.$store.state.auth.user,
    }
  },
  computed: {
    show() {
      return this.showDialog;
    }
  },
  mounted() {
  },
  props: {
  },
  methods: {
    beforeOpened(event) {
      const preset = event && event.params && event.params.link;
      this.linkGroup = preset ? String(preset) : '';
      this.showError = {
        isError: false,
        message: '',
      };
    },

    beforeClosed(event){
    },

    async requestJoin() {
      if (this.validate()) {
        return;
      }
      this.showError.isError = false;
      this.requestJoinLoading = true;

      try {
        const res = await ChatService.requestJoinGroup({
          group_id: this.chatGroupId,
          user_id: this.user.id,
        });
        if (res.status) {
          this.$store.dispatch("alerts/success", "Bạn đã yêu cầu vào nhóm thành công");
          this.$modal.hide('request-join-chat-group-modal');
        } else {
          this.showError.isError = true;
          const msg = String(res.message || '');
          if (msg.includes('Đã gửi yêu cầu')) {
            this.showError.message = 'Bạn đã gửi yêu cầu vào nhóm này. Vui lòng chờ quản trị viên phê duyệt.';
          } else if (msg.includes('thành viên')) {
            this.showError.message = 'Bạn đã là thành viên nhóm này.';
          } else {
            this.showError.message = msg || 'Không tồn tại nhóm này';
          }
        }
      } catch {
        this.showError.isError = true;
        this.showError.message = 'Đã có lỗi xảy ra. Vui lòng thử lại.';
      } finally {
        this.requestJoinLoading = false;
      }
    },
    validate() {
      this.linkGroup = this.linkGroup.trim();
      if (this.linkGroup === '') {
        this.showError.isError = true;
        this.showError.message = 'Bạn cần nhập link nhóm';
        return true;
      }

      const groupId = parseMessengerGroupIdFromLink(this.linkGroup);
      if (!groupId) {
        this.showError.isError = true;
        this.showError.message = 'Link không hợp lệ. Ví dụ: https://domain/messenger/123';
        return true;
      }

      this.chatGroupId = groupId;
      return false;
    }

  }

}
</script>

<style lang="scss">
  .request-join-chat-group-modal {
    .gs-group {
      min-height: 100px;
    }
  }

</style>
